<template>
  <div class="col group-card ">
    <div class="card mb-2 cardbg border-0">
      <!--      <div v-if="$store.state.user.check_is_wxc_domain()" class="class-right-top-tag green">-->
      <!--       <span >最 热</span>-->
      <!--      </div>-->
      <!--      <div v-else class="class-right-top-tag yellow">-->
      <!--        <span >最 热</span>-->
      <!--      </div>-->
      <div class=" text-center pt-3 gb-bg" id="author" :class="{noborder:type=='small'}">
        <div :class="{'group-card-avatar shadow-sm':type=='default','small':type=='small'}">
          <router-link :to="'/group/index/'+curent_data.id">
            <div v-if="!curent_data.avatar" class="avatar-word shadow-sm" style="width: 60px;height:60px;background-color: #eee;border-radius: 5%;line-height: 60px;text-align: center;font-weight: 500;font-size: 27px;margin: 0 auto">
              {{ curent_data.name.substring(0, 1).toUpperCase() }}
            </div>
            <img style="width:60px;height:60px;background: #fff"
                 v-if="curent_data.avatar"
                 v-bind:alt="curent_data.name"
                 class="rounded"
                 v-bind:src="curent_data.avatar"
            >
          </router-link>
        </div>
        <!--        成员-->
        <p class="h6 font-weight-normal mt-2 mb-0 text-center text-muted">
          {{$t('message').group.member_list_label1 }}
          {{ curent_data.count_member }}
          <!--          日发帖-->
          <!--          <span v-if="groupState.groupInfo.article_count_today>0" class="text-gray-dark">-->
          <!--                . {{ $t('message').group.group_todaynew_label }}:-->
          <!--                  {{ groupState.groupInfo.article_count_today }}</span>-->
          <!--          上月发帖-->
          <!--          <span v-if="groupState.groupInfo.article_count_today<=0 && groupState.groupInfo.article_count_lastMonth>0"-->
          <!--                class="text-gray-dark ">-->
          <!--                . {{ $t('message').group.group_lastmonth_label }}:{{ groupState.groupInfo.article_count_lastMonth }}-->
          <!--          </span>-->
        </p>
        <div class='align-self-center right pl-2 flex-grow-1'>
          <div class="d-flex align-self-center justify-content-between">
            <div :class="{'group-name':type=='default','small-name':type=='small'}">
            </div>

          </div>

        </div>
      </div>
      <div class="card-body pt-1 px-3 pb-2 text-center">
        <router-link :to="'/group/index/'+curent_data.id">
          <h3 style="height: 33px;overflow: hidden;" class="card-title font-weight-bold text-dark">
            <i style="width:13px" v-if="curent_data.is_private" class=" el-icon-lock text-muted small"></i>
            {{ curent_data.name|textTrans }}
          </h3>
        </router-link>

        <div id="description" class="description" :title="curent_data.description">
          {{ curent_data.description|textTrans }}
        </div>
        <div>
          <a v-if="!curent_data.userinfo_userID.is_in_group && curent_data.is_private===1"
             class="btn btn-primary text-white  btn-add border-0"
             @click="joniGroup(curent_data.id)">
            <div style="width:100px" class="d-flex justify-content-center  align-items-center btn-outline-secondary font-medium rounded-sm">
              <!--               <icon-plus :style="{fill:'#fff'}"></icon-plus>-->
              {{ $t('message').group.group_add }}
            </div>
          </a>
          <router-link :to="'/group/index/'+curent_data.id">
            <a style="width: 100px"  v-if="curent_data.userinfo_userID.is_in_group || curent_data.is_private===0"
               class="outline-btn  btn border btn-link text-default  py-2 cancel-add font-weight-bold ">
              逛逛
            </a>
          </router-link>
        </div>
      </div>
      <!--      <login-dialog ref="dialog"></login-dialog>-->
    </div>
    <login-dialog ref="dialog"></login-dialog>
  </div>
</template>
<script>
// import {IconPlus} from '@/components/Icons';
// import {IconCheck, IconPlus, IconX} from '@/components/Icons';
import {Button,} from '@/components';
import LoginDialog from '@/module/user/login/LoginDialog';
import {textTrans} from '@/directives/textTrans.js';
// import LoginDialog from '../../../../user/login/LoginDialog';

export default {
  name: 'group-list-item',
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type',
      inputData:{},
    },
    groupID: Number,
    data: {
      userID: Number,
      count_adder: Number,
      count_buzz: Number,
      count_article: Number,
      count_comment: Number,
      count_read: Number,
      description: String,
      userinfo_userID: {
        id: Number,
        username: String,
        avatar: String,
        description: String,
        verified: Number,
        status: Number,
        first_letter: String,
        is_hot_blogger: Number,
        is_adding: Number
      }
    },
    usertype: String
  },
  components: {
    [Button.name]: Button,
    LoginDialog
    // IconPlus,
    // IconCheck,
    // IconX,
    // LoginDialog
  },
  methods: {
    joniGroup(GroupID) {
      if(!this.check_user_login())  return;
      this.$store.dispatch('group/joniGroup', GroupID).then(res => {
        if(res.status){
          if(this.groupState.groupTopBar.is_private===1){
            this.$message.success('您的申请已经提交，请留意悄悄话中的社情审批结果。')
            this.joinBtnStatus = 1 ;
          }
          if (this.groupState.groupTopBar.is_private === 0) {
            this.$message.success('恭喜您已经加入群吧');
            this.$router.go(0)
          }
        }else{
          this.$router.go(0)
          // this.$message.warning(res.error);
        }
      })
    },
  },
  member_apply(id) {
    if(!this.check_user_login())  return;
    group.member_apply(id).then(res => {
      if (res.status) {
        this.curent_data.userID.is_adding = 1;
      }
    });
  },
  data() {
    return {
      userID: this.$store.state.user.userinfo.id,
      groupState: this.$store.state.group,
      memberList: this.$store.state.group.memberList,
      loginuserID: -1,
      error: '',
      curent_data: this.data,
      joinBtnStatus: 0,
      domain:'',
    }
  },
  filters: {
    textTrans(string) {
      return textTrans(string);
    }
  },
  created: function () {
    this.domain = location.host;
  },
  watch: {
    data(val) {
      this.curent_data = val
    }
  }
}

</script>
<style>
.group-card .card {
  box-shadow: 0px 4px 5px 0px rgb(0 0 0 / 10%);
  border: 1px solid #9e9e9e38;
  border-radius: 6px;
}

/*.group-cardbtn :hover{*/
/*  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);*/
/*}*/
hr.light {
  background-color: #9e9e9e52;
  height: 1px;
  border: 0;
}

.group-card {
  padding: 0 3px;
}

.group-card.noborder {
  border-top: 0;
}

.group-card a {
  color: #607D91;
  text-decoration: none;

}
.gb-bg {
  background: -webkit-gradient(linear,left top, left bottom,from(#39b8eb29),to(rgba(255,170,10,0)));
  background: linear-gradient(180deg,#39b8eb14,rgba(255,170,10,0));
}
.group-card a:hover {
  color: #235592
}
.class-right-top-tag.green{
  background-image: url(/img/hot-bgwxc.svg)
}
.class-right-top-tag.yellow{
  background-image: url(/img/hot-bg.svg)

}
.class-right-top-tag {
  position: absolute;
  top: -4px;
  right: -1px;
  width: 84px;
  height: 59.92px;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  word-spacing: -0.8px;
  letter-spacing: -.6px;
  text-align: right;
  background-size: 100%;
  background-repeat: no-repeat;
  color: #fff;
  z-index: 2;
}
.class-right-top-tag span{
  display: block;
  letter-spacing:1px;
  margin-top: 9px;
  text-align: center;
  -webkit-transform: rotate(36deg) translateX(12px);
  -ms-transform: rotate(36deg) translateX(12px);
  transform: rotate(36deg) translateX(12px);
  white-space: nowrap;
  text-overflow: clip;
  font-weight: normal;
  font-size:15px
}
/*.group-card .description {*/
/*  max-width: 236px;*/
/*  max-height: 21px;*/
/*  line-height: 22px;*/
/*  font-size: 15px;*/
/*  color: #404141;*/
/*  height: 44px;*/
/*  overflow: hidden;*/
/*  margin-bottom: 5px;*/
/*  text-overflow: ellipsis;*/
/*  white-space: nowrap;*/
/*}*/
.group-card .description {
  max-width: 205px;
  max-height: 25px;
  line-height: 23px;
  font-size: 15px;
  color: #404141;
  height: 96px;
  overflow: hidden;
  margin-bottom: 5px;
}
.group-card .description a {
  color: #657786
}

.group-card-avatar .avatar-word, .small .avatar-word {
  border-radius: 5%;
  background-color: #eeeeee;
  line-height: 60px;
  text-align: center;
  font-weight: 500;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
  font-size: 27px;
}

.group-card-avatar .avatar-word, .small .avatar-word:hover {
  background-color: #eeeeee;
}

.group-card-avatar .avatar-word {
  min-width: 60px
}
.font-medium{
  font-size: 19px;
}
.group-card .small .lable {
  position: absolute;
  margin-left: 20px;
  margin-top: -14px;
  transform: rotate(33deg)
}

.group-card-avatar .lable {
  position: absolute;
  margin-left: 28px;
  margin-top: -14px;
  transform: rotate(27deg)
}

.group-card-avatar {
  width: 60px;
  height: 60px;
  text-align: center;
  display: inline-table;
}

.group-card-avatar .rounded-circle, .group-card-avatar .avatar-word:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}

.small {
  width: 13px;
}

.group-card-avatar img {
  min-width: 60px;
  height: 60px;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
  border: 1px solid #eee;
}

.small img {
  width: 36px;
  height: 36px;
}

.small .avatar-word {
  width: 38px;
  height: 38px;
  line-height: 38px;
  font-size: 1rem;
}

.group-name {
  font-size: 1rem;
  font-weight: 600;

}

.group-name span {
  color: #333
}

.small-name {
  font-size: .95rem;
  font-weight: 600;

}

.cancel-add span.cancel-text, .cancel-add:hover span.added-text {
  display: none;
}

.cancel-add span.added-text, .cancel-add:hover span.cancel-text {
  display: block;
}

.cancel-add, .btn-add {
  padding: 0;
}

.group-card .right a {
  padding: 0;
}

.group-card .right .btn {
  margin: 0;
}

.group-card .right .btn .add {
  fill: #35abbb;
  font-size: 1rem;
  /* border-radius: 20px;
  padding: 3px 13px; */
}

.group-card .right .btn:hover .add {
  fill: #236e85;
}

.group-card .right .description {
  font-size: medium;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: 4px;
}

.group-cardbtn .btn-primary {
  padding: 10px 0;
  background-image: linear-gradient(-25deg, #00bcd4, #009cde);
  border-color: #03a1dc;
  -webkit-box-shadow: 0 2px 4.8px .3px rgb(0 0 0/15%);
  box-shadow: 0 2px 4.8px .3px rgb(0 0 0/15%)
}

.el-tooltip__popper, .tooltip-inner {
  min-width: 32px !important;
}
@media (min-width: 576px){
  .group-card .cardbg:hover {
    box-shadow: 0 8px 10px rgb(133 140 148 / 40%), 0 0 2px #c4c7cc;
  }
}
@media (max-width: 575.98px) {
  .list-itme .list-itme-image {
    margin: auto 0;
    margin-left: .5rem;
  }

  .imgspace {
    width: 90px;
    height: 90px;
  }

  .group-card {
    padding: 12px 0;
  }

  .group-card .right .description {
    display: none;
  }

  .cancel-add span.cancel-text.text-danger {
    display: block;
    color: #888 !important;
  }

  .cancel-add span.added-text {
    display: none;
  }
  .avatar-word.shadow-sm{
    min-width: 60px;
  }
}
</style>
